module.exports = {
  NgProbeToken: {},
  _createConditionalRootRenderer: function(rootRenderer, extraTokens, coreTokens) {
    return rootRenderer; 
  },
  __platform_browser_private__: {} 
};  
  


//////////////////
// WEBPACK FOOTER
// ./~/@angular/core/src/debug/debug_node.js
// module id = 371
// module chunks = 0